import React from "react";

const NotFound = () => {
    return (
        <div className="container mx-auto text-center">
            <div
                className="flex justify-center items-center"
                style={{ padding: "120px" }}
            >

                <div>
                    <h1>404 Page Not Found</h1>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
